module.exports = __webpack_public_path__ + "static/media/iso_27001.37a61654.pdf";